import { motion } from "framer-motion";
import Seo from "../components/Seo";

const paragraphs = [
  "I photograph what makes me stop.",
  "Sometimes that is light, shape or colour. Sometimes it is a face, an animal, a landscape, or something ordinary that has become briefly strange. I\u2019m interested in the moment when one thing suggests another, and in the connections that appear when photographs are allowed to sit beside each other without being forced into categories.",
  "This site grew from that idea.",
  "Rather than organising the work into conventional galleries, the photographs are connected by visual, emotional and sometimes slightly improbable associations. There is no intended route through them and no particular place you are supposed to end up. Start somewhere, follow whatever catches your attention, and see where it takes you.",
  "Some photographs belong together for obvious reasons. Others probably only make sense to me. A few connections may make no sense at all.",
  "That is part of it.",
  "These are photographs and other pieces of visual work made because I wanted to make them, collected here because I wanted somewhere for them to live and be seen.",
  "Nothing here is for sale.",
  "Just wander.",
];

export default function About() {
  return (
    <main
      data-testid="about-page"
      className="min-h-screen bg-[color:var(--bg)] text-white pt-32 pb-24 grain"
    >
      <Seo
        title="About"
        description="A written statement by Carol Lines about the work collected here and the labyrinth of associations that connects it."
        path="/about"
      />
      <div className="max-w-2xl mx-auto px-6 md:px-10">
        <article className="space-y-8">
          {paragraphs.map((p, i) => (
            <motion.p
              key={i}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{
                duration: 0.9,
                delay: i * 0.05,
                ease: [0.2, 0.7, 0.1, 1],
              }}
              data-testid={`about-paragraph-${i}`}
              className={
                i === paragraphs.length - 1
                  ? "font-serif-display italic text-white/85 text-2xl md:text-3xl leading-snug pt-4"
                  : "font-serif-display text-white/80 text-lg md:text-xl leading-relaxed"
              }
            >
              {p}
            </motion.p>
          ))}
        </article>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, delay: 0.2 }}
          className="mt-24 flex items-center justify-between text-xs md:text-sm text-white/45 font-serif-display italic"
          data-testid="about-footer-note"
        >
          <span>Personal work · Not for sale</span>
          <a href="/contact" className="hover:text-white/85 nav-link" data-testid="about-contact-link">
            Contact
          </a>
        </motion.p>
      </div>
    </main>
  );
}
